export default "__VITE_ASSET__BRRiRqRb__"